module.exports = __webpack_public_path__ + "img/replayAttachment.82aa6b8c.svg";